module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBkPSJNNSwxMyBDNC40NDc3MTUyNSwxMyA0LDEyLjU1MjI4NDcgNCwxMiBDNCwxMS40NDc3MTUzIDQuNDQ3NzE1MjUsMTEgNSwxMSBMMTksMTEgQzE5LjU1MjI4NDcsMTEgMjAsMTEuNDQ3NzE1MyAyMCwxMiBDMjAsMTIuNTUyMjg0NyAxOS41NTIyODQ3LDEzIDE5LDEzIEw1LDEzIFoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/hr.svg
// module id = 3MpJ
// module chunks = 1